export const OUTSOURCED_COMPANY_CATEGORIES = Object.freeze({
  FULL_DEPARTMENT: '1',
  MANAGER_ONLY: '2',
  CONTRACTED: '3',
  IN_HOUSE: '4',
  IN_HOUSE_CONTRACT_MANAGEMENT: '5',
});

export const OWNERSHIP_TYPES = Object.freeze({
  OWNED: '1',
  LEASED: '2',
  RENTAL: '3',
  FINANCED: '4',
  PHARMACY: '5',
  FACILITY: '6',
});

export const SOCIAL_MEDIA_OPTIONS = [
  { label: 'Facebook', value: 'hasFaceBook' },
  { label: 'Instagram', value: 'hasInstagram' },
  { label: 'TikTok', value: 'hasTikTok' },
  { label: 'Snapchat', value: 'hasSnapChat' },
  { label: 'LinkedIn', value: 'hasLinkedIn' },
];

export const CLINICAL_EQUIPMENT_OPTIONS = [
  { label: 'Lifts', value: 'hasLifts' },
  { label: 'Bladder Scanners', value: 'hasBladderScanners' },
  { label: 'VS Machine', value: 'hasVSMachine' },
  { label: 'Glucometers', value: 'hasGlucometers' },
  { label: 'Pulse Ox', value: 'hasPulseOx' },
];
